import { countries } from '@topcon/topcon-utils';

import { AddressInfo } from '../api/generated/pm';

/**
 * Resolves a 2-letter ISO country code to its display name, falling back to
 * the raw code when the lookup misses (unknown/legacy codes).
 */
export function getCountryName(countryCode: string): string {
  return countries.getCountry(countryCode)?.name ?? countryCode;
}

/**
 * Formats a `pm` service {@link AddressInfo} into a single, human-readable line
 * by joining its populated parts with commas. The country field is expanded
 * from its 2-letter ISO code to a display name via {@link getCountryName}.
 * Returns an empty string when no address (or no populated part) is available.
 */
export function formatAddress(address: AddressInfo | undefined | null): string {
  if (!address) return '';
  return [
    address.addressLineOne,
    address.zipPostalCode,
    address.city,
    address.country && getCountryName(address.country),
  ]
    .filter(Boolean)
    .join(', ');
}
